import Nav from "@/components/Nav";
import CategoryBar from "@/components/CategoryBar";
import Manifesto from "@/components/Manifesto";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import { CartProvider } from "@/components/CartContext";
import Seo, { SITE_URL } from "@/components/Seo";

export default function About() {
  return (
    <CartProvider>
      <main data-testid="about-page" className="overflow-x-clip">
        <Seo
          title="About Us | Canadian Beats Marketplace — Candy & Toy Shop in Nova Scotia"
          description="Canadian Beats Marketplace is a small candy and toy shop in Meteghan River, Nova Scotia. Candy for everyone, toys and sensory finds, and a Facebook community full of new drops and giveaways."
          canonical={`${SITE_URL}/about`}
          jsonLd={{
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "Home", item: `${SITE_URL}/` },
              { "@type": "ListItem", position: 2, name: "About Us", item: `${SITE_URL}/about` },
            ],
          }}
        />
        <Nav />
        <CategoryBar />
        <Manifesto />
        <Footer />
        <CartDrawer />
      </main>
    </CartProvider>
  );
}
